(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eb-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }
    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  if (!customElements.get('hg-mobile-navigation')) {
    customElements.define('hg-mobile-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.currentScreen = 'root';
        this.screenPositions = new Map();
        this.drawer = this.closest('header-drawer');
        this.drawerDetails = this.drawer && this.drawer.querySelector('details');
        this.scroller = this.closest('.menu-drawer__navigation-container');
        this.onNavigationClick = this.handleClick.bind(this);
        this.onNavigationKeydown = this.handleKeydown.bind(this);
        this.onNavigationKeyup = this.handleKeyup.bind(this);
        this.onDrawerToggle = () => {
          if (!this.drawerDetails.open) {
            this.screenPositions.clear();
            this.showScreen('root', null, false);
          }
        };
        this.addEventListener('click', this.onNavigationClick, true);
        if (this.drawer) {
          this.drawer.addEventListener('keydown', this.onNavigationKeydown, true);
          this.drawer.addEventListener('keyup', this.onNavigationKeyup, true);
          this.drawerDetails.addEventListener('toggle', this.onDrawerToggle);
        }
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onNavigationClick, true);
        if (this.drawer) {
          this.drawer.removeEventListener('keydown', this.onNavigationKeydown, true);
          this.drawer.removeEventListener('keyup', this.onNavigationKeyup, true);
          this.drawerDetails.removeEventListener('toggle', this.onDrawerToggle);
        }
        this.initialized = false;
      }
      screens() { return Array.from(this.querySelectorAll('[data-hg-screen]')); }
      activeScreen() { return this.screens().find(screen => screen.dataset.hgScreen === this.currentScreen); }
      showScreen(id, focusTarget, moveFocus = true) {
        const target = this.screens().find(screen => screen.dataset.hgScreen === id);
        if (!target) return;
        if (this.scroller) this.screenPositions.set(this.currentScreen, this.scroller.scrollTop);
        this.screens().forEach(screen => { screen.hidden = screen !== target; });
        this.currentScreen = id;
        if (this.scroller) this.scroller.scrollTop = this.screenPositions.get(id) || 0;
        if (moveFocus) {
          const destination = focusTarget || target.querySelector('.hg-screen-heading') || target.querySelector('button, a[href]');
          if (destination) {
            if (typeof trapFocus === 'function' && this.drawerDetails) trapFocus(this.drawerDetails, destination);
            destination.focus({ preventScroll: true });
          }
        }
      }
      goBack() {
        const active = this.activeScreen();
        if (!active || !active.dataset.hgParent) return;
        const previousId = this.currentScreen;
        const parent = this.screens().find(screen => screen.dataset.hgScreen === active.dataset.hgParent);
        const opener = parent && Array.from(parent.querySelectorAll('[data-hg-go]')).find(button => button.dataset.hgGo === previousId);
        this.showScreen(active.dataset.hgParent, opener);
      }
      handleClick(event) {
        const button = event.target.closest('[data-hg-go], [data-hg-back]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        // Existing theme code binds every drawer button to closeSubmenu.
        // Handle screen controls in capture phase so that handler never runs.
        event.stopImmediatePropagation();
        if (button.hasAttribute('data-hg-back')) this.goBack();
        else this.showScreen(button.dataset.hgGo);
      }
      handleKeydown(event) {
        if (!this.drawerDetails || !this.drawerDetails.open) return;
        if (event.key === 'Escape' && this.currentScreen !== 'root') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (event.key !== 'Tab') return;
        // The theme's generic focus helper includes links in hidden screens.
        // Keep keyboard focus among visible controls, including the close icon.
        const controls = Array.from(this.drawer.querySelectorAll('summary, a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]'))
          .filter(element => element.getClientRects().length > 0 && !element.closest('[hidden]'));
        if (!controls.length) return;
        const index = controls.indexOf(document.activeElement);
        const next = index < 0 ? (event.shiftKey ? controls.length - 1 : 0)
          : (index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
        event.preventDefault();
        event.stopImmediatePropagation();
        controls[next].focus();
      }
      handleKeyup(event) {
        if (event.key !== 'Escape' || this.currentScreen === 'root') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.goBack();
      }
    });
  }

  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => { if (disclosure && typeof disclosure.close === 'function') { disclosure.close(); } });
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  /* New-style menus only: keep dropdown panels inside the screen */
  function positionMegaMenu(details) {
    var panel = details.querySelector('.mega-menu__content');
    if (!panel || !details.open) return;
    var vw = window.innerWidth;
    var margin = 16;
    panel.style.transform = '';
    panel.style.maxWidth = '';
    var rect = panel.getBoundingClientRect();
    if (rect.width > vw - margin * 2) {
      panel.style.maxWidth = (vw - margin * 2) + 'px';
      rect = panel.getBoundingClientRect();
    }
    var overflowRight = rect.right - (vw - margin);
    if (overflowRight > 0) {
      var maxShift = rect.left - margin;
      var shift = Math.min(overflowRight, maxShift);
      if (shift > 0) {
        panel.style.transform = 'translateX(-' + shift + 'px)';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.header__inline-menu[data-nav-style="new"] .mega-menu').forEach(function(details) {
      details.addEventListener('toggle', function() {
        if (!details.open) {
          var panel = details.querySelector('.mega-menu__content');
          if (panel) { panel.style.transform = ''; panel.style.maxWidth = ''; }
          return;
        }
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            positionMegaMenu(details);
          });
        });
      });
    });

    /* New-style top nav: parent items with children go to their page on click (desktop) */
    document.querySelectorAll('#HeaderContent .header__inline-menu[data-nav-style="new"] .mega-menu > summary[data-url]').forEach(function(summary) {
      summary.addEventListener('click', function(e) {
        if (window.innerWidth < 1180) return;
        var url = summary.getAttribute('data-url');
        if (!url || url === '#') return;
        window.location.href = url;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["influencer-get-the-look-section"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const $$drawerTriggers = document.querySelectorAll('.InfluencerGetTheLook__drawerBtn')
    const $$drawerOverlays = document.querySelectorAll('.InfluencerGetTheLook__drawerOverlay')

    $$drawerTriggers.forEach((elem) => {
      elem.addEventListener('click', (e) => {
        const look = e.currentTarget.getAttribute('data-look')
        const $selectedDrawer = document.querySelector(`.InfluencerGetTheLook__imageContainer[data-look="${look}"]`)
        const $$currentActiveDrawers = document.querySelectorAll(
          '.InfluencerGetTheLook__imageContainer[data-active="true"]'
        )

        $$currentActiveDrawers?.forEach((activeElem) => {
          activeElem.setAttribute('data-active', false)
        })

        $selectedDrawer?.setAttribute('data-active', true)
      })
    })

    $$drawerOverlays.forEach((elem) => {
      elem.addEventListener('click', (e) => {
        const look = e.currentTarget.getAttribute('data-look')
        const $selectedDrawer = document.querySelector(`.InfluencerGetTheLook__imageContainer[data-look="${look}"]`)

        $selectedDrawer?.setAttribute('data-active', false)
      })
    })
  })()

  } catch(e) { console.error(e); }
})();
})();
